import React, { useState, useEffect } from 'react';
import Preloader from '../Preloader/Preloader';

const BOOTSTRAP_STEPS = [
    { id: 'client',  label: 'Establishing connection' },
    { id: 'key',     label: 'Securing your session'   },
    { id: 'session', label: 'Checking account status' },
];

const delay = (ms) => new Promise((res) => setTimeout(res, ms));

const fetchWithRetry = async (url, retries = 3) => {
    for (let attempt = 0; attempt < retries; attempt++) {
        try {
            const res = await fetch(url, { method: 'POST', credentials: 'include' });
            if (res.ok) return true;
        } catch {}
        if (attempt < retries - 1) await delay(1000);
    }
    return false;
};

const AppBootstrap = ({ children }) => {
    const [steps, setSteps] = useState(
        BOOTSTRAP_STEPS.map((s) => ({ ...s, status: 'pending' }))
    );
    const [ready, setReady]         = useState(false);
    const [failedStep, setFailedStep] = useState(null); // which step label failed

    const updateStep = (id, status) =>
        setSteps((prev) => prev.map((s) => (s.id === id ? { ...s, status } : s)));

    useEffect(() => {
        const bootstrap = async () => {
            // Step 1 — client
            updateStep('client', 'loading');
            const clientOk = await fetchWithRetry('/api/auth/new-x-api-client-internal');
            if (!clientOk) {
                updateStep('client', 'error');
                setFailedStep('Establishing connection');
                return; // hard stop — do NOT set ready
            }
            updateStep('client', 'done');

            // Step 2 — key (only runs if client succeeded)
            updateStep('key', 'loading');
            const keyOk = await fetchWithRetry('/api/auth/new-x-api-key');
            if (!keyOk) {
                updateStep('key', 'error');
                setFailedStep('Securing your session');
                return; // hard stop — do NOT set ready
            }
            updateStep('key', 'done');

            // Step 3 — auth check (visual only)
            updateStep('session', 'loading');
            try {
                await fetch('/api/auth/check', { credentials: 'include' });
            } catch {}
            updateStep('session', 'done');

            setReady(true);
        };

        bootstrap();
    }, []);

    if (!ready) return <Preloader steps={steps} failedStep={failedStep} />;

    return children;
};

export default AppBootstrap;
